import React from 'react';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import PropTypes from 'prop-types';

class RadioButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.isChecked = this.isChecked.bind(this);
  }

  isChecked({ id, value }) {
    if (id) {
      return this.props.value === id;
    }

    return this.props.value === value;
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.options.map((option, idx) => (
            <React.Fragment key={option.value}>
              <label
                className="radio inline"
                htmlFor={`${this.props.id}${idx}`}
              >
                {option.text}
              </label>
              <input
                onChange={this.props.onChange}
                type="radio"
                className="input-large radio inline"
                id={`${this.props.id}${idx}`}
                name={this.props.id}
                value={option.value}
                checked={this.isChecked(option)}
              />
            </React.Fragment>
          ))
        }
      </React.Fragment>
    );
  }
}

RadioButton.defaultProps = {
  value: '',
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};


export default withStaticBuilder(RadioButton);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/RadioButton.jsx